import { authPost } from "@api/auth/auth";

import { ActionBody, ActionResponse } from "@pages/settings/types";
/**
 * Sends request to create a new action with actionBody
 * Recommended that you use the useDeleteAction react-query mutation instead
 */
export const createAction = (deploymentId: string, actionBody: ActionBody) => {
  return authPost<ActionBody, ActionResponse>(
    `/api/agent/deployments/${deploymentId}/actions`,
    actionBody
  );
};
